import { gql } from '@apollo/client';

const GET_CATEGORIES = gql`
  query categories($params: QueryParams, $name: String) {
    categories(params: $params, name: $name) {
      info {
        count
      }
      results { 
        id
        name
        img
        priority
        description
        products {
          id
          name
          description
          variants {
            id
            title
            img
            description
            price
            isPrimaryVariant
          }
          type
        }
      }    
    }
  }
`;

const GET_CATEGORIES_SORTED = gql`
  query categories($params: QueryParams) {
    categories(params: $params) {
      info {
        count
      }
      results { 
        id
        name
        description
        priority
      }    
    }
  }
`;

const DELETE_CATEGORY = gql`
  mutation deleteCategory($id: ID!) {
    deleteCategory(id: $id)
  }
`;

export { GET_CATEGORIES, DELETE_CATEGORY, GET_CATEGORIES_SORTED }
